export default __webpack_public_path__ + "static/media/GHSI Regular Board Minutes 16 March 2022.0cbfc7dc.pdf";